// This file exists because in a Node context TS can't compile CSS modules,
// so we put type information shared between Node and the browser here
// rather than in component files.
import { BlogQueryResultItem, MDXFile, Page, Post, Snippet } from "../graphql";

export interface PostContext {
  post: Post;
  previous?: Post;
  next?: Post;
}

export const ARCHIVE_SNIPPET = "archive";

export interface BlogArchivePageContext {
  posts: BlogQueryResultItem[];
}

export interface ArchivePageContext {
  intro: Snippet;
  posts: BlogQueryResultItem[];
  numPages: number;
  currentPage: number;
}

export interface ContentPageContext {
  page: MDXFile<Page>;
}

export const MediaTypes = {
  MP3: "audio/mpeg",
} as const;
export type MediaType = (typeof MediaTypes)[keyof typeof MediaTypes];
